"use client";

import React from "react";
import { CartDrawer, ShopProvider, ShopProviderConfig } from "@webelocity/ui";
import { QueryClientProvider } from "@tanstack/react-query";
import queryClient from "@/util/react-query-client";

type ShopProvidersClientProps = {
  config: ShopProviderConfig;
  publicEnv: Record<string, unknown>;
  children: React.ReactNode;
};

export default function ShopProvidersClient({
  config,
  publicEnv,
  children,
}: ShopProvidersClientProps) {
  return (
    // <QueryClientProvider client={queryClient}>
    <ShopProvider config={{ ...config, queryClient }} publicEnv={publicEnv}>
      {children}
      <CartDrawer />
    </ShopProvider>

    // </QueryClientProvider>


  );
}
